import { NUMERIC_ATTRS } from "../constants";
import { isBlankText, isElement, isText, raw } from "../helpers";
import type { ElementNode, ParsedNode } from "../types";
import { parsePair } from "./pair";

type Override = (el: Element) => ParsedNode | undefined;

const toJson = (el: Element, override: Override): ParsedNode => {
  const replaced = override(el);
  if (replaced) return replaced;

  const json: ElementNode = { type: el.tagName.toLowerCase(), level: 0, children: [] };
  Array.from(el.attributes).forEach(({ name, value }) => {
    if (name === "class") {
      json.className = value;
    } else {
      json.attrs = json.attrs || {};
      if (NUMERIC_ATTRS[name]) json.attrs[NUMERIC_ATTRS[name]] = Number(value);
      else json.attrs[name] = value;
    }
  });
  json.children = childrenToJson(el, override);
  return json;
};

const elementToJson = (el: Element, override: Override): ParsedNode => {
  try {
    return toJson(el, override);
  } catch {
    return raw(el.outerHTML);
  }
};

const textToJson = (text: string): ParsedNode => parsePair(text) ?? { type: "text", level: 0, text };

const childrenToJson = (node: Node, override: Override): ParsedNode[] => {
  const out: ParsedNode[] = [];
  node.childNodes.forEach((child) => {
    if (isElement(child)) out.push(elementToJson(child, override));
    else if (isText(child) && !isBlankText(child)) out.push(textToJson(child.data));
  });
  return out;
};

export { childrenToJson };
